import { all, call, debounce, put } from 'redux-saga/effects';

import {
  getCharacterPositions,
  getGuides,
  getWorkExpirience,
} from 'data-providers/mainAnketaProvider';

import { setError, setLoading, setReferenceBooks } from './actions';
import { ACTIONS, FIELDS } from './constants';

function* getReferenceBooks() {
  try {
    yield put(setLoading(true));

    const [referenceBooks, characterPositions, workExpirience] = yield all([
      call(getGuides),
      call(getCharacterPositions),
      call(getWorkExpirience),
    ]);

    if (!referenceBooks) {
      return;
    }

    if (characterPositions) {
      referenceBooks[FIELDS.CHARACTER_POSITIONS] = characterPositions;
      referenceBooks[FIELDS.CHARACTER_POSITION_LIST] = characterPositions;
    }

    if (workExpirience) {
      referenceBooks[FIELDS.WORK_EXPIRIENCE] = workExpirience;
    }

    yield put(setReferenceBooks(referenceBooks));
  } catch (error) {
    yield put(setError(error));
  } finally {
    yield put(setLoading(false));
  }
}

export function* referenceBooksWatchGetReferenceBooks() {
  yield debounce(50, ACTIONS.GET_REFERENCE_BOOKS, getReferenceBooks);
}
